import React, { Component } from 'react';
import './AvailablePricesFilter.css';
import CheckboxFilter from './CheckboxFilter';
import ParameterErrors from '../errors/ParameterErrors';
import Option from '../choices/Option';
import MenuType from '../enums/MenuType';
import SubMenuHeader from './SubMenuHeader';
import ClickedOffManager from '../ui_core/ClickedOffManager';
import numberWithCommas from '../core/numberWithCommas';
import AssetsManager from '../assets_management/AssetsManager';
const {throwNotProvided}=ParameterErrors;
export default class AvailablePricesFilter extends Component {
	constructor(props){
		super(props);
		const {onSelectedOptionsChange} = props;
		this._callbackSelectedOptionsChange=onSelectedOptionsChange;
		this._checkboxFilter = React.createRef();
		this._subMenuHeader = React.createRef();
		this._element = React.createRef();
		this._dynamicallyGetFromPriceWithLowerRange = this._dynamicallyGetFromPriceWithLowerRange.bind(this);
		this._roundDownToNearest100 = this._roundDownToNearest100.bind(this);
		this._roundUpToNearest100=this._roundUpToNearest100.bind(this);
		this._getAndUpdateOptions = this._getAndUpdateOptions.bind(this);
		this._createPriceIntervalsFromPlotsArrayOrdered = this._createPriceIntervalsFromPlotsArrayOrdered.bind(this);
		this._updateOptions = this._updateOptions.bind(this);
		this._iMenuManager  = null;
		this._clickedOffHandle = null;
		this.show = this.show.bind(this);
		this.hide= this.hide.bind(this);
		this.filterPlots = this.filterPlots.bind(this);
		this.clear = this.clear.bind(this);
		this._iMenuManager  = null;
		this.state = {options:[], visible:false};
		this._clickedOffManager = new ClickedOffManager({elementRef:this._element, hide:this.hide});
	}
	setFromWhatAreYouLookingForViewModel(whatAreYouLookingForViewModel){
		const priceRange = whatAreYouLookingForViewModel.priceRange;
		if(priceRange===undefined||priceRange===null)return;
		const from = priceRange[0], to =priceRange[1];
		const hasFrom = from!==undefined&&from!==null;
		const hasTo = to!==undefined&&to!==null;
		const checkboxOption = this._checkboxFilter.current.getCheckboxOptions()
			.map(checkboxOption=>checkboxOption.ref.current)
			.forEach(checkboxOption=>{
				const value= checkboxOption.value;
				const hasFromAndFromIsInsideRangeForCheckbox = hasFrom&&(from>=value.from&&from<=value.to);
				const hasToAndToIsInsideRangeForCheckbox = hasTo&&(to>=value.from&&to<=value.to);
				const hasFromAndToAndConsumesEntireCheckboxRange = hasFrom&&hasTo&&(to>=value.to&&from<=value.from);
				checkboxOption.isChecked =hasFromAndFromIsInsideRangeForCheckbox
				||hasToAndToIsInsideRangeForCheckbox
				||hasFromAndToAndConsumesEntireCheckboxRange;
			});
		this._callbackSelectedOptionsChange();
	}
	show(){
		this.setState({visible:true});
		this._clickedOffManager.register();
		this._iMenuManager.showMe(this);
	}
	hide(){
		this.setState({visible:false});
		this._clickedOffManager.dispose();
		this._iMenuManager.close();
	}
	filterPlots(plotsArray){
		const priceRangesToShow = this._checkboxFilter.current.getCheckedValues();
		if(priceRangesToShow.length<1)return plotsArray;
		const plotsToShow = [];
		for(var i=0; i<plotsArray.length; i++){
			const plot = plotsArray[i];
			const price = plot.price;
			for(var j=0; j<priceRangesToShow.length; j++){
				const priceRangeToShow = priceRangesToShow[j];
				if(price>=priceRangeToShow.from&&price<=priceRangeToShow.to)
				{
					plotsToShow.push(plot);
					break;
				}
			}
		}
		return plotsToShow;
	}
	get isApplied(){
		return this._checkboxFilter.current.isApplied;
	}
	clear(){
		this._checkboxFilter.current.clear();
	}
	setIMenuManager(value){
		this._iMenuManager = value;
		this._subMenuHeader.current.setIMenuManager(value);
	}
	get menuType(){
		return MenuType.AVAILABLE_PRICES_FILTER;
	}
	load({plotsArray, availablePricesSettings, currencyConfiguration}){
		if(!availablePricesSettings)throwNotProvided('availablePricesSettings');
		if(!currencyConfiguration)throwNotProvided('currencyConfiguration');
		this._getAndUpdateOptions(plotsArray, availablePricesSettings, currencyConfiguration);
	}
	_createPriceIntervalsFromPlotsArrayOrdered(plotsInPriceOrder){
		var index=0;
		const priceRanges = [];
		let currentPriceFrom =100000;
		let priceIncrement=AssetsManager.configuration.priceIncrement;
		if(priceIncrement===null||priceIncrement===undefined||priceIncrement<=0)
			priceIncrement=100000;
		while(index<plotsInPriceOrder.length){
			const nextPrice = currentPriceFrom+priceIncrement;
			if(nextPrice>plotsInPriceOrder[index].price)
			{
				
				let price;
				var hadOneGreaterThanZero = false;
				while(index<plotsInPriceOrder.length&&(price = plotsInPriceOrder[index].price)<=nextPrice){
					if(price>0)hadOneGreaterThanZero=true;
					index++;
				}
				if(hadOneGreaterThanZero)
					priceRanges.push({from:currentPriceFrom, to:nextPrice});
			}
			currentPriceFrom = nextPrice;
		}
		return priceRanges;
	}
	_getAndUpdateOptions(plotsArray, availablePricesSettings, currencyConfiguration){
		const plotsInPriceOrder = plotsArray.sort(function(plotA, plotB){return plotA.price - plotB.price});
		let desiredPriceIntervalsPlusDynamicallyAddedPriceIntervalsPrice =
			availablePricesSettings.desiredIntervalsPrice;
		if(AssetsManager.configuration.priceIncrement||desiredPriceIntervalsPlusDynamicallyAddedPriceIntervalsPrice.length<1){
			this._updateOptions(this._createPriceIntervalsFromPlotsArrayOrdered(plotsInPriceOrder), currencyConfiguration.currencyPrefix, currencyConfiguration.currencySuffix);
			return;
		}
		let from = null;
		const requiredRanges =[];
		let previousPriceIntervalWithToLessThan = null;
		const dynamicRangesSeen=[];
		plotsInPriceOrder.forEach((plot)=>{
			if(plot.price<=0)return;
			let foundRange =false;
			var i=0;
			for(i=0; i<desiredPriceIntervalsPlusDynamicallyAddedPriceIntervalsPrice.length; i++){
				const priceInterval = desiredPriceIntervalsPlusDynamicallyAddedPriceIntervalsPrice[i];
				if(priceInterval.from<=plot.price){
					if(priceInterval.to>=plot.price){
						if(requiredRanges.indexOf(priceInterval)<0){
							requiredRanges.push(priceInterval)
						}
						foundRange=true;
						break;
					}
					previousPriceIntervalWithToLessThan = priceInterval;
				}
				else break;
				
			}
			if(!foundRange){
				const nextPriceInterval=i<desiredPriceIntervalsPlusDynamicallyAddedPriceIntervalsPrice.length
				?desiredPriceIntervalsPlusDynamicallyAddedPriceIntervalsPrice[i]
				:null;
				const range = this._dynamicallyGetFromPriceWithLowerRange(previousPriceIntervalWithToLessThan, plot.price, nextPriceInterval);
				const dynamicRangeString = `{range.from}_{range.to}`;
				if(dynamicRangesSeen.indexOf(dynamicRangeString)>=0)return;
				dynamicRangesSeen.push(dynamicRangeString);
				requiredRanges.push(range);
			}
		});
		this._updateOptions(requiredRanges, currencyConfiguration.currencyPrefix, currencyConfiguration.currencySuffix);
	}
	_dynamicallyGetFromPriceWithLowerRange(previousPriceInterval, price, nextPriceInterval){
		const priceRoundedDownToNearest100=this._roundDownToNearest100(price);
		let from = priceRoundedDownToNearest100;
		if(from<0)
			from = 0;
		if(previousPriceInterval!=null){
			if(previousPriceInterval.to>priceRoundedDownToNearest100)
				from = previousPriceInterval.to;
		}
		let to = this._roundUpToNearest100(price);
		if(nextPriceInterval!==null){
			if(nextPriceInterval.from<to)
				to = nextPriceInterval.from;
		}
		return {from:from, to:to};
	}
	_roundDownToNearest100(price){
		return price-(price%100);
	}
	_roundUpToNearest100(price){
		const mod = (price%100);
		return /*mod>0?*/price+100-mod/*:price*/;
	}
	_checkboxFilterOptionsChanged(){
		
	}
	_updateOptions(requiredRanges, currencyPrefix, currencySuffix){
		const options = requiredRanges.map((requiredRange)=>new Option({text:`${currencyPrefix}${numberWithCommas(requiredRange.from)}${currencySuffix} to ${currencyPrefix}${numberWithCommas(requiredRange.to)}${currencySuffix}`,
			value:requiredRange}));
		this._checkboxFilter.current.setOptions(options);
	}
	render() {
		let className = "available-prices-filter menu";
		if(this.state.visible)
			className+=" visible";
		return (<div className={className} ref={this._element}>
				<SubMenuHeader ref={this._subMenuHeader} title="Available prices"></SubMenuHeader>
				<CheckboxFilter ref={this._checkboxFilter} onSelectionChange={this._callbackSelectedOptionsChange}></CheckboxFilter></div>)
	}
}
